import _extends from "@babel/runtime/helpers/esm/extends";
import { ELanguage } from '../common';
import { fieldsIBaseModel } from './base';
import { EModel } from './model';
import { EPatientFormTemplateType } from './patient-form-template';
export let EFormQuestionTypeKeys;
(function (EFormQuestionTypeKeys) {
  EFormQuestionTypeKeys["address"] = "address";
  EFormQuestionTypeKeys["allergy"] = "allergy";
  EFormQuestionTypeKeys["copay"] = "copay";
  EFormQuestionTypeKeys["date"] = "date";
  EFormQuestionTypeKeys["demographics"] = "demographics";
  EFormQuestionTypeKeys["dropdown"] = "dropdown";
  EFormQuestionTypeKeys["eSignature"] = "e_signature";
  EFormQuestionTypeKeys["email"] = "email";
  EFormQuestionTypeKeys["familyHistory"] = "family_history";
  EFormQuestionTypeKeys["group"] = "group";
  EFormQuestionTypeKeys["immunizationHistory"] = "immunization_history";
  EFormQuestionTypeKeys["informationCapture"] = "information_capture";
  EFormQuestionTypeKeys["insuranceCard"] = "insurance_card";
  EFormQuestionTypeKeys["insuranceVerification"] = "insurance_verification";
  EFormQuestionTypeKeys["jump"] = "jump";
  EFormQuestionTypeKeys["longText"] = "long_text";
  EFormQuestionTypeKeys["medicationList"] = "medication_list";
  EFormQuestionTypeKeys["medicationSearch"] = "medication_search";
  EFormQuestionTypeKeys["multipleChoice"] = "multiple_choice";
  EFormQuestionTypeKeys["patientInformation"] = "patient_information";
  EFormQuestionTypeKeys["pharmacySearch"] = "pharmacy_search";
  EFormQuestionTypeKeys["phoneNumber"] = "phone_number";
  EFormQuestionTypeKeys["shortText"] = "short_text";
  EFormQuestionTypeKeys["socialHistory"] = "social_history";
  EFormQuestionTypeKeys["ssn"] = "ssn";
  EFormQuestionTypeKeys["surgicalHistory"] = "surgical_history";
  EFormQuestionTypeKeys["template"] = "template";
  EFormQuestionTypeKeys["twoFactor"] = "2FA";
  EFormQuestionTypeKeys["yesNo"] = "yes_no";
  EFormQuestionTypeKeys["zipcode"] = "zipcode";
})(EFormQuestionTypeKeys || (EFormQuestionTypeKeys = {}));
export let EPatientFormStatus;
(function (EPatientFormStatus) {
  EPatientFormStatus["Pending"] = "pending";
  EPatientFormStatus["Unstarted"] = "unstarted";
  EPatientFormStatus["Started"] = "started";
  EPatientFormStatus["Completed"] = "completed";
})(EPatientFormStatus || (EPatientFormStatus = {}));
export let EPatientFormIntegratorUpdateResultsStatus;
(function (EPatientFormIntegratorUpdateResultsStatus) {
  EPatientFormIntegratorUpdateResultsStatus["Success"] = "success";
  EPatientFormIntegratorUpdateResultsStatus["Failure"] = "failure";
  EPatientFormIntegratorUpdateResultsStatus["Pending"] = "pending";
  EPatientFormIntegratorUpdateResultsStatus["PartialFailure"] = "partial-failure";
  EPatientFormIntegratorUpdateResultsStatus["NotSupported"] = "not-supported";
})(EPatientFormIntegratorUpdateResultsStatus || (EPatientFormIntegratorUpdateResultsStatus = {}));
export let EPatientFormDirectMessageCcdaUpdateResultsStatus;
(function (EPatientFormDirectMessageCcdaUpdateResultsStatus) {
  EPatientFormDirectMessageCcdaUpdateResultsStatus["Success"] = "success";
  EPatientFormDirectMessageCcdaUpdateResultsStatus["Failure"] = "failure";
  EPatientFormDirectMessageCcdaUpdateResultsStatus["Pending"] = "pending";
})(EPatientFormDirectMessageCcdaUpdateResultsStatus || (EPatientFormDirectMessageCcdaUpdateResultsStatus = {}));
export let EPatientFormProcessingStatus;
(function (EPatientFormProcessingStatus) {
  EPatientFormProcessingStatus["Open"] = "open";
  EPatientFormProcessingStatus["InProgress"] = "in-progress";
  EPatientFormProcessingStatus["Closed"] = "closed";
})(EPatientFormProcessingStatus || (EPatientFormProcessingStatus = {}));
export let EPatientFormStaffReviewStatus;
(function (EPatientFormStaffReviewStatus) {
  EPatientFormStaffReviewStatus["Reviewed"] = "reviewed";
  EPatientFormStaffReviewStatus["Awaiting"] = "awaiting";
})(EPatientFormStaffReviewStatus || (EPatientFormStaffReviewStatus = {}));
export let EPatientFormAnswerStatus;
(function (EPatientFormAnswerStatus) {
  EPatientFormAnswerStatus["Added"] = "added";
  EPatientFormAnswerStatus["Updated"] = "updated";
  EPatientFormAnswerStatus["Deleted"] = "deleted";
  EPatientFormAnswerStatus["NotChanged"] = "not-changed";
})(EPatientFormAnswerStatus || (EPatientFormAnswerStatus = {}));
export const fieldsPatientForm = _extends({}, fieldsIBaseModel, {
  accessedFrom: {
    type: 'Text'
  },
  answers: {
    type: 'Unknown'
  },
  answersStatus: {
    type: 'Object'
  },
  appointment: {
    type: 'ID',
    ref: EModel.Appointment
  },
  appointmentChecklist: {
    type: 'Text'
  },
  availabilities: {
    type: 'ID',
    ref: EModel.Availability,
    array: true
  },
  calculationResult: {
    type: 'Unknown'
  },
  categoryNameToWritebackPDF: {
    type: 'Text'
  },
  completedAt: {
    type: 'Date'
  },
  currentItemId: {
    type: 'Text'
  },
  deletedAnswers: {
    type: 'Unknown'
  },
  directMessageCcdaUpdateResults: {
    type: 'Object'
  },
  duration: {
    type: 'Number'
  },
  externalInformation: {
    type: 'Object'
  },
  facilities: {
    type: 'ID',
    ref: EModel.Facility,
    array: true
  },
  fileUpload: {
    type: 'ID',
    ref: EModel.FileUpload
  },
  finalDisposition: {
    type: 'Unknown'
  },
  integratorUpdateResults: {
    type: 'Object'
  },
  jumpLogic: {
    type: 'Object'
  },
  language: {
    type: 'Option',
    values: ELanguage
  },
  lumabot: {
    type: 'Boolean'
  },
  nextPatientForm: {
    type: 'ID',
    ref: EModel.PatientForm
  },
  offer: {
    type: 'ID',
    ref: EModel.Offer
  },
  path: {
    type: 'Text',
    array: true
  },
  patient: {
    type: 'ID',
    ref: EModel.User
  },
  patientFormTemplate: {
    type: 'ID',
    ref: EModel.PatientFormTemplate
  },
  patientFormTemplateName: {
    type: 'Text'
  },
  patientFormTemplateType: {
    type: 'Option',
    values: EPatientFormTemplateType
  },
  previousPatientForm: {
    type: 'ID',
    ref: EModel.PatientForm
  },
  processingStatus: {
    type: 'Option',
    values: EPatientFormProcessingStatus
  },
  processingStatusUpdatedAt: {
    type: 'Date'
  },
  processingStatusUpdatedBy: {
    type: 'ID',
    ref: EModel.User
  },
  querystring: {
    type: 'Unknown'
  },
  questionsForStaffReview: {
    type: 'Object'
  },
  ref: {
    type: 'Text'
  },
  refId: {
    type: 'Text'
  },
  reviewedAnswers: {
    type: 'Object'
  },
  staffReviewStatus: {
    type: 'Option',
    values: EPatientFormStaffReviewStatus
  },
  status: {
    type: 'Option',
    values: EPatientFormStatus
  },
  url: {
    type: 'Text'
  },
  version: {
    type: 'Text'
  },
  writebackOptions: {
    type: 'Unknown'
  },
  writebackPDFToEhr: {
    type: 'Boolean'
  },
  writebackToEhr: {
    type: 'Boolean'
  },
  // Nested fields
  responses: {
    type: 'Object',
    values: {
      path: {
        type: 'Text',
        array: true
      },
      currentItemId: {
        type: 'Text'
      }
    }
  }
});